import {Component, OnDestroy, OnInit} from '@angular/core';
import {ReplaySubject} from 'rxjs';
import {UserPermissions} from '../../../shared/interface/user-permissions';
import {ActivatedRoute} from '@angular/router';
import {MatSnackBar} from '@angular/material/snack-bar';
import {MatDialog} from '@angular/material/dialog';
import {AuthService} from '../../../shared/services/auth.service';
import {takeUntil} from 'rxjs/operators';
import {HttpErrorResponse} from '@angular/common/http';
import {Meeting} from '../../../shared/interface/meeting';
import {MeetingService} from '../../../shared/services/meeting.service';
import {MEETING_STATUS_DURING_REGISTRATIONS, MEETING_TYPE_EXAM, MEETING_TYPE_IDD_TRAINING, MEETING_TYPE_NEW_AGENT_TRAINING,
  MEETING_TYPE_ADA, MEETING_TYPE_TRAINING, MEETING_TYPE_MEETING, MEETING_TYPE_OTHER, MEETING_TYPE_ENTRANCE_EXAM} from '../../../shared/services/dict.service';

@Component({
  selector: 'app-meeting-details',
  templateUrl: './meeting-details.component.html',
  styleUrls: ['./meeting-details.component.scss']
})
export class MeetingDetailsComponent implements OnInit, OnDestroy {
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  readonly MEETING_STATUS_DURING_REGISTRATIONS = MEETING_STATUS_DURING_REGISTRATIONS;
  readonly MEETING_TYPE_EXAM = MEETING_TYPE_EXAM;
  readonly MEETING_TYPE_IDD_TRAINING = MEETING_TYPE_IDD_TRAINING;
  readonly MEETING_TYPE_NEW_AGENT_TRAINING = MEETING_TYPE_NEW_AGENT_TRAINING;
  readonly MEETING_TYPE_ADA = MEETING_TYPE_ADA;
  readonly MEETING_TYPE_TRAINING = MEETING_TYPE_TRAINING;
  readonly MEETING_TYPE_MEETING = MEETING_TYPE_MEETING;
  readonly MEETING_TYPE_OTHER = MEETING_TYPE_OTHER;
  readonly MEETING_TYPE_ENTRANCE_EXAM = MEETING_TYPE_ENTRANCE_EXAM;

  meetingId: string;
  meetingObject?: Meeting;
  meeting: ReplaySubject<Meeting> = new ReplaySubject<Meeting>(1);
  modify = false;
  userPermissions: ReplaySubject<UserPermissions>;

  constructor(
    private route: ActivatedRoute,
    private meetingService: MeetingService,
    private snack: MatSnackBar,
    private dialog: MatDialog,
    private auth: AuthService,
  ) {
    this.userPermissions = auth.getUserPermissions();
  }

  ngOnInit(): void {
    this.route.params
      .pipe(takeUntil(this.destroyed$))
      .subscribe(params => {
        this.meetingId = params.id;
        this.loadMeeting();
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  loadMeeting(): void {
    this.meetingService.get(this.meetingId).subscribe((meeting: Meeting) => {
      this.meeting.next(meeting);
      this.meetingObject = meeting;
    }, (error: HttpErrorResponse) => {
      this.snack.open('Nie udało się pobrać danych egzaminu/szkolenia', error.status.toString(), {
        duration: 2000
      });
    });
  }
}
